import { MarketBanner, MarketLink } from '@market/react-bindings';
import * as React from 'react';
import { useI18n } from '@goparrot-dashboard/i18n';

interface Props {
  msg: string;
}

export const ErrorBanner: React.FC<Props> = ({ msg }) => {
  const { getIntlString } = useI18n();
  const CONTACT_US_URL = 'https://squareup.com/help/us/en/topic/square-for-franchises';

  return (
    <MarketBanner variant="critical">
      {getIntlString(msg)}
      <MarketLink href={CONTACT_US_URL} target="_blank" slot="action" destructive={true}>
        {getIntlString(getLinkLabel(msg))}
      </MarketLink>
    </MarketBanner>
  );
};

const getLinkLabel = (msg: string) => {
  switch (msg) {
    case 'error.toastDeprecationBanner.body':
      return 'error.toastDeprecationBanner.link.label';
    default:
      return 'error.notFoundSSOUserVisible.link.label';
  }
};
